import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { DistrictSelectorViewModel } from "../districtManipulation/districtSelector";
import { PersonnelSearchableSelectorViewModel } from "../personnelManipulation/personnelSelector";
import  { WorkAsManipulationView } from "./workAsManipulation-view"

export class WorkAsManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'صدور حکم';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.workAs = ObservableArray.create<workAs>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new WorkAsManipulationView();
    }
    public getTypeId(): string {
        return "VM-A3ADC60C-CC67-4584-999E-A5B6C637B30D"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set workAs(v: ObservableArray<workAs>) { this._workAs = v; } public get workAs(): ObservableArray<workAs> { return this._workAs;} private _workAs: ObservableArray<workAs>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetAllWorkAs',{
                FilteringInformation:filteringInformation
            });
            this.workAs.update(...result.WorkAs.map(q=>{
                let r = new workAs(this);
                r.id = q.Id;
                r.districtId = q.DistrictId;
                r.districtName = q.DistrictName;
                r.personnelId = q.PersonnelId;
                r.personnelName = q.PersonnelFullName;
                r.from = moment.utc(q.From);
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async requestWorkAsCreation(){
        let editor = new workAsEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }

    async accept(id:any){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/WorkAsInvalidator',{
                Id:id
            });
            await this.messageBoxConfirmSuccess('حکم غیر فعال شد','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }
}
export class workAs extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:WorkAsManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set personnelId(v: string) { this._personnelId = v; } public get personnelId(): string { return this._personnelId;} private _personnelId: string;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName;} private _personnelName: string;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    
        
    private _typedParent:WorkAsManipulationViewModel;

    setDistrict(id: string, name: string) {
        this.districtId = id;
        this.districtName = name;
    }
    getDistrictId() {
        return this.districtId;
    }    

    setPersonnel(id: string, name: string) {
        this.personnelId = id;
        this.personnelName = name;
    }
    getPersonnelId() {
        return this.personnelId;
    }
    
    async inactiveWorkAs():Promise<void>{
        let result:string; 
        result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','غیرفعال کردن حکم');
        if(result=='yes'){
            this._typedParent.accept(this.id);
        }
    }

}

interface IServerUpdater{
    execute(workAs:workAs):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'صدور حکم با موفقیت ثبت شد.';
    }
    async execute(workAs: workAs): Promise<void> {
        await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/CreateWorkAs',{
            Personnel:workAs.getPersonnelId(),
            District:workAs.getDistrictId()
        });
    }
}

class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'حکم با موفقیت به روز رسانی شد.';

    }
    async execute(workAs: workAs): Promise<void> {
        
    }
}

export class workAsEditor extends workAs implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:WorkAsManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.districtSelector = new DistrictSelectorViewModel(this);
        this.personnelSelector = new PersonnelSearchableSelectorViewModel(this, false, null, true, false, false, false, true);
        this.personnelSelector.onSelectionChanged = q=>{
            this.personnelName = q.title;
            this.personnelId = q.id;
        }
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set districtSelector(v: DistrictSelectorViewModel) { this._districtSelector = v; } public get districtSelector(): DistrictSelectorViewModel { return this._districtSelector;} private _districtSelector: DistrictSelectorViewModel;
    public set personnelSelector(v: PersonnelSearchableSelectorViewModel) { this._personnelSelector = v; } public get personnelSelector(): PersonnelSearchableSelectorViewModel { return this._personnelSelector;} private _personnelSelector: PersonnelSearchableSelectorViewModel;
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.getDistrictId())){
            result.push(' شعبه مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.getPersonnelId())){
            result.push(' پرسنل مشخص نشده است.')
        }
        return result;
    }
    setDistrict(id: string, name: string) {
        this.districtSelector.selectById(id);
    }

    setPersonnel(id: string, name: string) {
        this.personnelSelector.selectById(id);
    }

    getDistrictId() {
        return this.districtSelector.selectedItem.id;
    }

    getPersonnelId() {
        return this.personnelSelector.selectedItem.id;
    }
    
    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت حکم');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }

}